import type {
  StringValidatorFn,
  StringValidatorInput,
  ValidateReturn,
} from '../formValidator.types';

export type MinLengthOptions = {
  minLength: number;
  errorMessage: string;
};

const defaultOptions: MinLengthOptions = {
  minLength: 2,
  errorMessage: 'Must be at least {{minLength}} characters long',
};

const validateInput = (
  input: StringValidatorInput = '',
  options: Partial<MinLengthOptions> = defaultOptions,
): ValidateReturn => {
  const opts = { ...defaultOptions, ...options };
  const stringInput = input || '';
  return stringInput.length < opts.minLength
    ? opts.errorMessage.replace(/{{minLength}}/, opts.minLength.toString())
    : undefined;
};

export const validateMinLength = (
  input: StringValidatorInput,
): ValidateReturn => validateInput(input);

export const getValidateMinLengthFn = (
  options: Partial<MinLengthOptions>,
): StringValidatorFn => {
  return (input: StringValidatorInput) => validateInput(input, options);
};
